<template>
  <div class="row">
    <div class="col-md-12 marker-details">
      <h3>
        <span class="highlight">{{$t('individual_records')}}</span>
        <Menu/>
      </h3>
    </div>
  </div>
</template>

<script>
import Menu from './Menu.vue'

export default {
  components: {
    Menu
  },
}
</script>



// WEBPACK FOOTER //
// Details.vue?1b7069c3